module.exports = __webpack_public_path__ + "static/media/H0_Footer-14.bef82b83.png";